import React from 'react';
import Typewriter from 'typewriter-effect';

import Typing from './Typing';
import 'primeicons/primeicons.css';
import './hero.scss';
import HandEmoji from './hand-emoji.png';
import HeroImg from './hero-img.png';

class Hero extends React.Component {
  render() {
    return (
      <div className="hero">

        <div className="p-grid p-justify-center">
          <div className="p-md-12 p-lg-6 hero-text">
            <div className="hero-gretting">
              Hello,<img src={HandEmoji} className="hand-emoji-img" /> <br />
            I am Viraj {'\n'} Gawde
            </div>
            <div className="typing">
              <Typewriter
                className="typing"
                onInit={(typewriter) => {
                  typewriter.typeString(`Fullstack developer<br/>Tech Enthusiast`)
                    .start();
                }}
              />
            </div>
          </div>
          <div className="p-md-12 p-lg-6 hero-img-wrapper">
            <img src={HeroImg} className="hero-img" />
          </div>
        </div>
      </div>
    )
  }
}

export default Hero;